/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_StatusInputs */

const id_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const ms_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const da_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const en_us2_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_es2_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const es_mx2_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fil_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katayuan`)
};

const fr_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const it_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const hu_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Állapot`)
};

const nl_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const no_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pl_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pt_br2_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pt_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const ro_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stare`)
};

const fi_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tila`)
};

const sv_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const vi_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

const tr_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum`)
};

const cs_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const bg_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const ru_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const uk_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const ar_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة`)
};

const hi_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const th_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถานะ`)
};

const ja_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ステータス`)
};

const zh_cn2_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const zh_hant1_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const ko_table_toolbar_status = /** @type {(inputs: Table_Toolbar_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Table_Toolbar_StatusInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_status = /** @type {((inputs?: Table_Toolbar_StatusInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_StatusInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_status(inputs)
	if (locale === "ms") return ms_table_toolbar_status(inputs)
	if (locale === "da") return da_table_toolbar_status(inputs)
	if (locale === "de") return de_table_toolbar_status(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_status(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_status(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_status(inputs)
	if (locale === "fil") return fil_table_toolbar_status(inputs)
	if (locale === "fr") return fr_table_toolbar_status(inputs)
	if (locale === "it") return it_table_toolbar_status(inputs)
	if (locale === "hu") return hu_table_toolbar_status(inputs)
	if (locale === "nl") return nl_table_toolbar_status(inputs)
	if (locale === "no") return no_table_toolbar_status(inputs)
	if (locale === "pl") return pl_table_toolbar_status(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_status(inputs)
	if (locale === "pt") return pt_table_toolbar_status(inputs)
	if (locale === "ro") return ro_table_toolbar_status(inputs)
	if (locale === "fi") return fi_table_toolbar_status(inputs)
	if (locale === "sv") return sv_table_toolbar_status(inputs)
	if (locale === "vi") return vi_table_toolbar_status(inputs)
	if (locale === "tr") return tr_table_toolbar_status(inputs)
	if (locale === "cs") return cs_table_toolbar_status(inputs)
	if (locale === "bg") return bg_table_toolbar_status(inputs)
	if (locale === "ru") return ru_table_toolbar_status(inputs)
	if (locale === "uk") return uk_table_toolbar_status(inputs)
	if (locale === "ar") return ar_table_toolbar_status(inputs)
	if (locale === "hi") return hi_table_toolbar_status(inputs)
	if (locale === "th") return th_table_toolbar_status(inputs)
	if (locale === "ja") return ja_table_toolbar_status(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_status(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_status(inputs)
	return ko_table_toolbar_status(inputs)
});
export { table_toolbar_status as "table.toolbar.status" }